export class DependentCardModel {
  id: string;
  holderName: string;
  number: string;
  balance: number;
  active: boolean;
  password: string;
  cardName: string;

  localId: string;
  cartaoCashlessId: string;
  statusDesejado: number;

  constructor() {
    this.balance = 0;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/dependentCard.model.ts